import { render, staticRenderFns } from "./ChoiceStepDocument.vue?vue&type=template&id=e78360f2&"
import script from "./ChoiceStepDocument.vue?vue&type=script&lang=js&"
export * from "./ChoiceStepDocument.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceStepDocument.vue?vue&type=style&index=0&id=e78360f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports